var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg32PtStaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M28.615 4h-4.738l-2.051 4h-.698l-2.933-8h-3.939l-2.79 8h-.676L8.738 4H4v16c0 6.627 5.51 12 12.308 12 6.797 0 12.307-5.373 12.307-12V4ZM6.051 6h1.416l2.051 4h3.426l2.79-8h1.025l2.933 8h3.405l2.052-4h1.415v8H6.051V6Zm0 14c0 5.523 4.592 10 10.257 10 5.664 0 10.256-4.477 10.256-10v-4H6.051v4Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg32PtStaf);
export default __webpack_public_path__ + "static/media/32pt_staf.b3e378fbdbe9bd4348211097d1955ead.svg";
export { ForwardRef as ReactComponent };